import { render, staticRenderFns } from "./ProductLMS.vue?vue&type=template&id=ee3bc538&"
import script from "./ProductLMS.vue?vue&type=script&lang=js&"
export * from "./ProductLMS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports